import { render, staticRenderFns } from "./SelectOption.vue?vue&type=template&id=1aef28b4&scoped=true"
import script from "./SelectOption.vue?vue&type=script&lang=js"
export * from "./SelectOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aef28b4",
  null
  
)

export default component.exports